export const DAEMON = '@@saga-injector/daemon';
export const FLAGS_NONREMOVABLE = 'nonremovable';
export const ID_PREFIX = 'tempID-';
export const INVALID_COMPONENT_CLASS = 'border-input-error';
export const LABEL_SUFFIX = '-label';
export const MOCK_BACKEND_ERROR_MESSAGE = 'Test Error from Mock Backend, Please Ignore';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const PREFIX_SCREEN = 'screen-';
export const PREFIX_FIELDS = 'fields-';
export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const REQUIRED_FIELD_PARAMETERS = ['name', 'type', 'label'];
export const SUFFIX_ERROR = '-error';
export const SF_TYPES = {
  BOOLEAN: 'boolean',
  PICKLIST: 'picklist',
  MULTIPICKLIST: 'multipicklist',
};

export const HOST_SET_ROUTE = 'host-set-route';

// Degree Program - Implied Consent Field Keys (Opt-out model)
export const DEFAULT_IMPLIED_PHONE_CONSENT_KEY = 'do_not_call';
export const DEFAULT_IMPLIED_EMAIL_CONSENT_KEY = 'email_opt_out';

// Short Course - Implied Consent Field Keys (Opt-in model)
export const DEFAULT_IMPLIED_PHONE_OPT_IN_KEY = 'call_opt_in';
export const DEFAULT_IMPLIED_EMAIL_OPT_IN_KEY = 'email_opt_in';

export const DEFAULT_IMPLIED_CONSENT_DISCLAIMER_VALUE =
  'By submitting this form, I consent to receive communications by phone, text message, WhatsApp and email via automated technology, including AI generative or prerecorded voice, from 2U about educational opportunities offered with its partners. I may opt out at any time. Consent is not required for purchase. [<link: target:blank]Privacy Notice[link>] and [<link: target:blank]SMS Terms[link>]';

export const DEFAULT_IMPLIED_CONSENT_DISCLAIMER_OVERRIDE =
  'By submitting this form, you agree that 2U, in partnership with the [University Name], may contact you regarding this course. Your personal data will be used as described in the [<link: target:blank]Privacy Policy[link>]. You may opt out of receiving communications at any time.';

export const DEFAULT_PHONE_HELP_TEXT = 'By entering your phone number, you consent to being contacted by an enrollment specialist to provide additional information and assistance with any questions you may have.';

export const DEFAULT_IMPLIED_CONSENT = {
  key: null,
  userDoesConsent: false,
  userDoesNotConsent: true,
};
export const DEFAULT_LEAD_SHARE_OPT_IN_CHECKBOX_TEXT = 'Please contact me about these programs.';

export const FIELD_NAMES = {
  COUNTRY: 'country',
  COUNTRY_OF_CITIZENSHIP: 'country_of_citizenship',
  LEAD_SHARE_OPT_IN: 'lead_share_opt_in',
  CONSENT_GDPR: 'consent_gdpr',
  CONSENT_NON_GDPR: 'consent_non_gdpr',
  PHONE: 'phone',
  DEGREE_OFFERING: 'degree_offering',
  CP_DEGREE_OFFERING: 'degree_offering_central_park',
  STATE: 'state',
  NATIONALITY: 'nationality',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email',
  MULTIPICKLIST: 'multipicklist',
  GDPR_PROSPECT_2U_OPT_IN: 'gdprProspect2uOptIn',
  GDPR_PROSPECTPARTNER_OPT_IN: 'gdpr_prospectpartner_opt_in',
  EMAIL_OPT_OUT: 'email_opt_out',
  EMAIL_OPT_IN: 'email_opt_in',
  PHONE_OPT_OUT: 'do_not_call',
  PHONE_OPT_IN: 'call_opt_in',
  SMS_OPT_IN_MARKETING: 'sms_opt_in_marketing',
};

export const FIELD_NAMES_HIDDEN = [FIELD_NAMES.DEGREE_OFFERING];
export const FIELD_NAMES_ADDED = [FIELD_NAMES.GDPR_PROSPECT_2U_OPT_IN, FIELD_NAMES.CONSENT_GDPR, FIELD_NAMES.CONSENT_NON_GDPR, FIELD_NAMES.CP_DEGREE_OFFERING, FIELD_NAMES.MULTIPICKLIST, FIELD_NAMES.GDPR_PROSPECTPARTNER_OPT_IN];

export const FIELD_OBJECTS_ADDED = {
  [FIELD_NAMES.GDPR_PROSPECT_2U_OPT_IN]: {
    apiFieldName: FIELD_NAMES.GDPR_PROSPECT_2U_OPT_IN,
    sfFieldType: 'boolean',
    sfPicklistValues: [],
  },
  [FIELD_NAMES.GDPR_PROSPECTPARTNER_OPT_IN]: {
    apiFieldName: FIELD_NAMES.GDPR_PROSPECTPARTNER_OPT_IN,
    sfFieldType: 'boolean',
    sfPicklistValues: [],
  },
};

export const BACKUP_CONSENT_FIELD_NAMES = [
  DEFAULT_IMPLIED_PHONE_CONSENT_KEY, // 'do_not_call' (Degrees)
  DEFAULT_IMPLIED_EMAIL_CONSENT_KEY, // 'email_opt_out' (Degrees)
  DEFAULT_IMPLIED_PHONE_OPT_IN_KEY, // 'call_opt_in' (Short Courses)
  DEFAULT_IMPLIED_EMAIL_OPT_IN_KEY, // 'email_opt_in' (Short Courses)
  'phone_opt_out',
  'sms_opt_in',
];

export const LEGACY_CONSENT_FIELD_NAMES = [
  FIELD_NAMES.CONSENT_GDPR,
  FIELD_NAMES.CONSENT_NON_GDPR,
];

export const EXPLICIT_CONSENT_FIELD_NAMES = [
  FIELD_NAMES.EMAIL_OPT_OUT,
  FIELD_NAMES.PHONE_OPT_OUT,
];

export const INFERRABLE_FIELD_NAME_MAP = {
  country: {
    shouldHideField: true,
    checkboxText: 'Enable inferred geo',
  },
  zip_code: {
    shouldHideField: false,
    checkboxText: 'State Lookup Based on Zip',
    helpText: 'If enabled and a US zip code is entered, State will be looked up and automatically sent with the prospect (do not put a State field on the form if used)',
  },
};

export const INFERRABLE_FIELD_NAMES = Object.keys(INFERRABLE_FIELD_NAME_MAP);
export const DEFAULT_OPTIN_DISCLAIMER = 'edX, and its parent company, 2U, offer other online education programs across various fields of study.';
export const DEFAULT_OPTIN_CHECKBOX_TEXT = 'Please contact me about these programs.';

export const FIELD_TYPES = {
  TEXT: 'text',
  DEGREE_OFFERING: 'degreeOffering',
  DROPDOWN: 'dropdown',
  RADIO_BUTTON: 'radiobutton',
  OPTIN: 'optin', // This field type is deprecated, use NON_GDPR_CONSENT or PICKLIST_VALUE_OPT_IN instead
  PICKLIST_VALUE_OPT_IN: 'picklist_value_opt_in',
  BOOLEAN_OPT_IN: 'booleanOptIn',
  GDPR_CONSENT: 'gdpr_consent',
  STATE: 'state',
  COUNTRY: 'country',
  NATIONALITY: 'nationality',
  ALWAYS_GDPR: 'alwaysGDPR',
  NON_GDPR_CONSENT: 'nonGDPRConsent',
  MULTIPICKLIST: 'multipicklist',
  GDPR_SETTING: 'gdprSetting',
  PHONE: 'phone',
  EMAIL: 'email',
};

export const FIELD_RULES = {
  REQUIRED: 'Required',
  HIDDEN: 'Hidden',
  GDPR_ONLY: 'GDPR Only',
  GDPR_OPTIONAL: 'Optional for GDPR',
  US_ONLY: 'US Only',
};

export const DATE_OPTIONS = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short',
};

export const OPTIN_FORMATS = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};
export const OPTIN_RADIO_DEFAULTS = {
  NONE: 'none',
  YES: 'yes',
  NO: 'no',
};
export const CONSENT_CHANNELS = ['email', 'phone', 'sms'];

export const PUBLISHED_STATUS = {
  PUBLISHED: 'Current',
  MODIFIED: 'Modified',
  UNPUBLISHED: 'Unpublished',
};

export const DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
};

export const DISCLAIMER_LOCATION_TYPES = {
  body: 'BODY',
  footer: 'FOOTER',
};

export const FORM_STYLE = {
  STANDARD: 'STANDARD',
  QUIZ: 'QUIZ',
};

export const GDPR_SETTING = {
  GEO: 'geo',
  ALWAYS: 'always',
  NEVER: 'never',
  ALWAYS_IMPLIED: 'always-implied',
  GEO_IMPLIED: 'geo-implied',
  PASS_CONSENT_FOR_ALL_USERS: 'send_consent_for_all_users',
};

export const LEGACY_GDPR_SETTINGS = [GDPR_SETTING.ALWAYS, GDPR_SETTING.GEO];
export const IMPLIED_GDPR_SETTINGS = [GDPR_SETTING.ALWAYS_IMPLIED, GDPR_SETTING.GEO_IMPLIED];
export const COMMON_EDITOR_OVERRIDE_FIELDS = [FIELD_NAMES.PHONE];
export const LEAD_SHARE_OVERRIDE_FIELDS = [FIELD_NAMES.LEAD_SHARE_OPT_IN];

export const CREDENTIAL_TYPES = {
  DEGREE: 'DEGREE',
  GRADUATE_CERTIFICATE: 'GRADUATE_CERTIFICATE',
  SHORT_COURSE: 'SHORT_COURSE',
};

export const DEFAULT_FIELDS_TO_REMOVE = new Set(['country', 'degree_offering_central_park', 'ip', 'state']);

export const FIELDS_TO_REMOVE = {
  [CREDENTIAL_TYPES.DEGREE]: new Set(['degree_offering_central_park', 'ip']),
  [CREDENTIAL_TYPES.SHORT_COURSE]: DEFAULT_FIELDS_TO_REMOVE,
  [CREDENTIAL_TYPES.GRADUATE_CERTIFICATE]: new Set(['degree_offering_central_park', 'ip']),
};

export const ACTIVE_CREDENTIAL_TYPES = [
  CREDENTIAL_TYPES.DEGREE,
  CREDENTIAL_TYPES.GRADUATE_CERTIFICATE,
  CREDENTIAL_TYPES.SHORT_COURSE,
];

export const CREDENTIAL_TYPE_COLUMNS = {
  [CREDENTIAL_TYPES.DEGREE]: ['Grouping', 'Degree Offering(s)'],
  [CREDENTIAL_TYPES.SHORT_COURSE]: ['Grouping', 'University Name'],
  [CREDENTIAL_TYPES.GRADUATE_CERTIFICATE]: ['Grouping', 'Degree Offering(s)'],
};

export const SHORT_ENV = {
  development: 'dev',
  production: 'prod',
  staging: 'stg',
};

export const GDPR_SETTING_DISPLAY_LABELS = {
  [GDPR_SETTING.GEO]: 'Geo-target (CSD) GDPR consent language',
  [GDPR_SETTING.GEO_IMPLIED]: 'Geo-target Implied GDPR consent language',
  [GDPR_SETTING.ALWAYS]: 'Always use GDPR consent language',
  [GDPR_SETTING.ALWAYS_IMPLIED]: 'Always use Implied GDPR consent language',
  [GDPR_SETTING.NEVER]: 'Never use GDPR consent language',
  [GDPR_SETTING.PASS_CONSENT_FOR_ALL_USERS]: 'Geo-Implied Consent for all Regions',
};
